module.exports = __webpack_public_path__ + "static/media/UA.af3a2e97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/countryFlags/UA.svg
// module id = 2094
// module chunks = 0